import { useAtomValue } from 'jotai'
import { lastSaveWorkDateAtom, isSavingWorkAtom } from '../../store/saveWorkAtoms'
import { useEffect, useState } from 'react'
import { TranslateFunction, useTar } from '@/modules/i18n'

const getSaveStatusText = (lastSaveDate: Date, t: TranslateFunction): string => {
  const now = new Date()
  const diffMs = now.getTime() - lastSaveDate.getTime()
  const diffMinutes = Math.floor(diffMs / (1000 * 60))
  const diffHours = Math.floor(diffMinutes / 60)
  const diffDays = Math.floor(diffHours / 24)
  if (diffMinutes < 1) {
    return t('common.savedJustNow')
  } else if (diffMinutes < 60) {
    return t('common.savedTIMEAgo', { time: `${diffMinutes}m` })
  } else if (diffHours < 24) {
    return t('common.savedTIMEAgo', { time: `${diffHours}h` })
  } else {
    return t('common.savedTIMEAgo', { time: `${diffDays}d` })
  }
}

export const LastWorkSave = () => {
  const { t } = useTar()
  const lastSaveDate = useAtomValue(lastSaveWorkDateAtom)
  const isSaving = useAtomValue(isSavingWorkAtom)
  const [, setStatusText] = useState(() => getSaveStatusText(lastSaveDate, t))


  const saveStatusText = isSaving ? t('common.saving') : getSaveStatusText(lastSaveDate, t)

  useEffect(() => {
    const timerToken = setInterval(() => {
      setStatusText(getSaveStatusText(lastSaveDate, t))
    }, 10_000)

    return () => clearInterval(timerToken)
  }, [lastSaveDate, t])

  return (
    <div className="flex items-center gap-2 hidden md:flex">
      <span className="text-xs text-primary">{saveStatusText}</span>
    </div>
  )
}
